import { Component } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { AuthService } from '../shared/services/auth.service';
import { UserManagementService } from '../shared/services/user-management.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  readonly viewDataIngestionModule: string[] = ['app.dcr-portal.s3-data-transfer.view'];

  readonly viewDataConnectionModule: string[] = [
    'app.dcr-portal.data-connection.action.create',
    'app.dcr-portal.data-connection.action.view',
    'app.dcr-portal.data-connection.action.delete',
    'app.dcr-portal.data-connection.action.edit',
  ];

  readonly viewQueryInterfaceModule: string[] = [
    'app.dcr-portal.query-interface.view',
    'app.dcr-portal.query-history.view',
    'app.dcr-portal.query-result.view',
    'app.dcr-portal.activation.view',
    'app.dcr-portal.audience-export-history.view',
  ];

  readonly viewUserManagementModule: string[] = [
    'app.dcr-portal.user-management.view',
    'app.dcr-portal.user-management.action.create',
    'app.dcr-portal.user-management.action.view',
    'app.dcr-portal.user-management.action.delete',
    'app.dcr-portal.user-management.action.edit',
  ];

  readonly supportEmail: string = 'dcr-admin@nfl.com';

  constructor(
    public appService: AppService,
    public authService: AuthService,
    public userManagementService: UserManagementService,
  ) {}

  openDCRHub() {
    window.open(this.appService.dcrHubLink, '_blank');
  }

  get firstName() {
    const name = this.userManagementService.getName();
    return name ? name.split(' ')[0] : '';
  }
}
